<div
  class="flex flex-col gap-2"
  [class.m-messages-full-screen]="fullScreen"
  [ngClass]="styleClass">
  @for (message of messages; track $index) {
    <p-message
      [severity]="message.severity"
      [closable]="closable"
      [size]="size"
      (onClose)="handleClose($event)">
      @if (message.icon) {
        <ng-template #icon>
          <span
            class="material-symbols-outlined m-message-icon"
            [style.color]="getIconColor(message.severity)"
            >{{ message.icon }}</span
          >
        </ng-template>
      }
      @if (message.summary) {
        @if (escape) {
          <span class="m-message-summary">{{ message.summary }}</span>
        } @else {
          <span class="m-message-summary" [innerHTML]="message.summary"></span>
        }
      }
      @if (escape) {
        <span class="m-message-detail">{{ message.detail }}</span>
      } @else {
        <span class="m-message-detail" [innerHTML]="message.detail"></span>
      }
    </p-message>
  }
  <ng-content></ng-content>
</div>
